"use client"

import Link from "next/link"

interface ResourceLinkProps {
   href: string
   ariaLabel: string
}

export function ResourceLink({ href, ariaLabel }: ResourceLinkProps) {
   return (
      <Link
         href={href}
         aria-label={ariaLabel}
          className="inline-flex items-center gap-2 rounded-lg bg-custom-primary p-4 text-base font-semibold text-white transition-transform"
      >
         Get Resource
         <span className="transition-transform duration-200 group-hover:translate-x-1">→</span>
      </Link>
   )
}
